export default __webpack_public_path__ + "static/media/location3.4cf5e6f3.png";